<template>
  <div>
    <el-input v-model="name" class="h-40 mw-240" :disabled="disabled" @input="change"></el-input>
  </div>
</template>
<script>
  import modelConfig from '../../../../config/modelConfig'
  export default {
    props: {
      'value': {
        type: String,
        default() {
          return ''
        }
      },
      'user': {
        type: Object
      },
      'disabled': {
        type: Boolean
      }
    },
    data() {
      return {
        name: ''
      }
    },
    created() {
      this.name = this.getUserInfo()
      this.change(this.name)
    },
    methods: {
      getUserInfo() {
        let name = ''
        if (this.value) {
          name = this.value
        } else {
          const userInfo = Lockr.get('userInfo')
          if (this.user.field) {
            name = userInfo[this.user.field]
          }
        }
        return name
      },
      change() {
        this.$emit('input', this.name)
      }
    },
    mixins: [modelConfig]
  }
</script>


// WEBPACK FOOTER //
// honrayUser.vue?44b74e40